import { isPhoneGap } from '@/modules/util/util'

import { Get, JsonP, Post } from './apiWrapper'

import moment from 'moment'

import { ModuleInfo } from '@/config/nameConfig'

import * as dbInteractions from '@/dbQuery/dbInteractions'

import * as Helper from '@/modules/helper/index'

export const loadLocalAppConfigData = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let appConfigTemp = {
      DesignSettings: null,
      MainMenu: null,
      Modules: {
        Items: []
      }
    }
    let designSettings = await dbInteractions.selectSubscriptionsDesignSettings(key)
    let mainMenu = await dbInteractions.selectSubscriptionsStartPages(key)
    let modules = await dbInteractions.selectSubscriptionsModules(key)

    if (designSettings.length > 0) {
      appConfigTemp.DesignSettings = designSettings[0]
    }
    if (mainMenu.length > 0) {
      appConfigTemp.MainMenu = mainMenu[0]
    }
    if (modules.length > 0) {
      appConfigTemp.Modules.Items = modules
    }
    return appConfigTemp
  }
}
export const loadAppConfig = async(key) => {
  let response = await Get(`AppConfigSync/${key}`)
  return response
}
export const loadLocalCustomCodeData = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let result
    let customCode = await dbInteractions.selectModulesCustomCode(key)
    if (customCode.length > 0) {
      result = customCode[0]
    }
    return result
  }
}
export const loadCustomCode = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let responce = await loadModuleData(key, ModuleInfo.Tables.ModulesCustomCode, phonegap)
    if (responce) {
      if (Helper.IsValid(responce, true)) {
        await addUpdatesyncTime(responce.Module_Id, key)
      }
      if (Helper.IsValid(responce, true)) {
        await dbInteractions.mergeModulesCustomCode(responce)
      }
    }
    return await loadLocalCustomCodeData(key)
  } else{
    return await loadModuleData(key, ModuleInfo.Tables.ModulesCustomCode, phonegap)
  }
}
export const loadChatData = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let responce = await loadModuleData(key, ModuleInfo.Tables.ModulesChats, phonegap)
    if (responce) {
      if (Helper.IsValid(responce, true)) {
        addUpdatesyncTime(responce.Module_Id, key)
      }
      if (Helper.IsValid(responce, true)) {
        await dbInteractions.mergeModulesChat(responce)
      }
    }
    return responce ? await loadLocalChatData(key) : null
  } else{
     return await loadModuleData(key, ModuleInfo.Tables.ModulesChats, phonegap)
  }
}

export const loadLocalChatData = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let result
    let chat = await dbInteractions.selectModulesChat(key)
    if (chat.length > 0) {
      result = chat[0]
    }
    return result
  }
}

export const loadTwitterLocalData = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let result
    let twitter = await dbInteractions.selectModulesTwitter(key)
    if (twitter.length > 0) {
      result = twitter[0]
    }
    return result
  }
}
export const loadTwitterData = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let responce = await loadModuleData(key, ModuleInfo.Tables.ModulesTwitter, phonegap)
    if (responce) {
      if (Helper.IsValid(responce, true)) {
        addUpdatesyncTime(responce.Module_Id, key)
      }
      if (Helper.IsValid(responce, true)) {
        await dbInteractions.mergeModulesTwitter(responce)
      }
    }
    return responce ? await loadTwitterLocalData(key) : null
  } else{
    return await loadModuleData(key, ModuleInfo.Tables.ModulesTwitter, phonegap)
  }
}

export const loadLocalInstagram = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let result
    let instagram = await dbInteractions.selectModulesInstagram(key)
    if (instagram.length > 0) {
      result = instagram[0]
    }
    return result
  }
}
export const loadInstagram = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let responce = await loadModuleData(key, ModuleInfo.Tables.ModulesInstagram, phonegap)
    if (responce) {
      if (Helper.IsValid(responce, true)) {
        addUpdatesyncTime(responce.Module_Id, key)
      }
      if (Helper.IsValid(responce, true)) {
        await dbInteractions.mergeModulesInstagram(responce)
      }
    }
    return await loadLocalInstagram(key)
  } else{
    return await loadModuleData(key, ModuleInfo.Tables.ModulesInstagram, phonegap)
  }
}

export const loadFacebook = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let responce = await loadModuleData(key, ModuleInfo.Tables.ModulesFacebook, phonegap)
    if (responce) {
      if (Helper.IsValid(responce, true)) {
        addUpdatesyncTime(responce.Module_Id, key)
      }
      if (Helper.IsValid(responce, true)) {
        await dbInteractions.mergeModulesFacebook(responce)
      }
    }
    return await loadLocalFacebook(key)
  } else{
    return await loadModuleData(key, ModuleInfo.Tables.ModulesFacebook, phonegap)
  }
}
export const loadLocalFacebook = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let result
    let instagram = await dbInteractions.selectModulesFacebook(key)
    if (instagram.length > 0) {
      result = instagram[0]
    }
    return result
  }
}
export const loadLocalWebsite = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let result
    let website = await dbInteractions.selectModulesWebsite(key)
    if (website.length > 0) {
      result = website[0]
    }
    return result
  }
}
export const loadWebsite = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let responce = await loadModuleData(key, ModuleInfo.Tables.ModulesWebsite, phonegap)
    if (responce) {
      if (Helper.IsValid(responce, true)) {
        await addUpdatesyncTime(responce.Module_Id, key)
      }
      if (Helper.IsValid(responce, true)) {
        await dbInteractions.mergeModulesWebsite(responce)
      }
    }
    return await loadLocalWebsite(key)
  } else{
    return await loadModuleData(key, ModuleInfo.Tables.ModulesWebsite, phonegap)
  }
}
export const loadLocalPdf = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let result
    let pdf = await dbInteractions.selectModulesPdf(key)
    if (pdf.length > 0) {
      result = pdf[0]
    }
    return result
  }
}
export const loadPdf = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {    
    let responce = await loadModuleData(key, ModuleInfo.Tables.ModulesPDF, phonegap)
    if (responce) {
      if (Helper.IsValid(responce, true)) {
        await addUpdatesyncTime(responce.Module_Id, key)
      }
      if (Helper.IsValid(responce, true)) {
        await dbInteractions.mergeModulesPdf(responce)
      }
    }
    return await loadLocalPdf(key)
  } else{
    return await loadModuleData(key, ModuleInfo.Tables.ModulesPDF, phonegap)
  }
}
export const loadYoutubeData = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let responce = await loadModuleData(key, ModuleInfo.Tables.ModulesYoutube, phonegap)
    if (responce) {
      if (Helper.IsValid(responce, true)) {
        addUpdatesyncTime(responce.Module_Id, key)
      }
      if (Helper.IsValid(responce, true)) {
        await dbInteractions.mergeModulesYoutube(responce)
      }
    }
    return await loadYoutubeLocalData(key) 
  } else{
    return await loadModuleData(key, ModuleInfo.Tables.ModulesYoutube, phonegap)
  }
}
export const loadYoutubeLocalData = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let result
    let youtube = await dbInteractions.selectModulesYoutube(key)
    if (youtube.length > 0) {
      result = youtube[0]
    }
    return result
  }
}

export const loadYoutubeChannelURL = async(URL) => {
  let response = await JsonP(URL)
  return response
}

export const loadRssFeedData = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let responce = await loadModuleData(key, ModuleInfo.Tables.ModulesRSSFeed, phonegap)
    if (responce) {
      if (Helper.IsValid(responce, true)) {
        addUpdatesyncTime(responce.Module_Id, key)
      }

      if (Helper.IsValid(responce, true)) {
        await dbInteractions.mergeModulesRssFeed(responce)
      }
    }
    return responce ? await loadRssFeedLocalData(key) : null
  } else {
    return await loadModuleData(key, ModuleInfo.Tables.ModulesRSSFeed, phonegap)
  }
}
export const loadRssFeedLocalData = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let result
    let rssfeed = await dbInteractions.selectModulesRssFeed(key)
    if (rssfeed.length > 0) {
      result = rssfeed[0]
    }
    return result
  }
}
export const loadRssFeedURL = async(key) => {
  let response = await Get(`ModuleRSSFeed/GetFeed?feedUrl=${key}`)
  return response
}
export const loadPDFData = async(Payload) => {  
  let response = await Post(`ModuleCustomCodeAuth/GetDirStructure`, Payload)
  return response
}
export const loadRadioStreamURL = async(key) => {
  let response = await Get(key)
  return response
}
// export const loadAppConfig = async(key) => {
//   let phonegap = isPhoneGap()
//   if (phonegap) {
//     let responce = await loadAppConfigData(key, 'AppConfigSync', phonegap)
//     if (responce) {
//       if (responce.DesignSettings || responce.MainMenu || (responce.Modules && responce.Modules.Items)) {
//         addUpdatesyncTime(ModuleInfo.Modules.AppConfig.moduleId, ModuleInfo.Modules.AppConfig.moduleId)
//       }
//       if (responce.DesignSettings) {
//         dbInteractions.mergeSubscriptionsDesignSettings(responce.DesignSettings)
//       }
//       if (responce.MainMenu) {
//         dbInteractions.mergeSubscriptionsStartPages(responce.MainMenu)
//       }
//       if (responce.Modules) {
//         dbInteractions.mergeSubscriptionsModules(responce.Modules.Items)
//       }
//     }
//     return loadLocalAppConfigData(key)
//   } else {
//     return loadAppConfigData(key, 'AppConfigSync', phonegap)
//   }
// }

export const loadTeamLocalData = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let teamInfo = {
      Parent: null,
      Persons: []
    }
    let teamParent = await dbInteractions.selectModulesTeamMembers(key)

    if (teamParent.length > 0) {
      teamInfo.Parent = teamParent[0]
    }

    let teamPersons = await dbInteractions.selectModulesTeamMembersPersons(teamInfo.Parent.Id)

    if (teamPersons.length > 0) {
      teamInfo.Persons = teamPersons
    }

    return teamInfo
  }
}
export const loadTeamData = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let responce = await loadModuleData(key, ModuleInfo.Tables.ModulesTeamMembers, phonegap)
    if (responce) {
      if (responce.Parent !== null || responce.Persons !== null) {
        await addUpdatesyncTime(ModuleInfo.Modules.Team.moduleId, key)
      }

      if (responce.Parent !== null) {
        await dbInteractions.mergeModulesTeamMembers(responce.Parent)
      }

      if (responce.Persons !== null) {
        await dbInteractions.mergeModulesTeamMembersPersons(responce.Persons)
      }
    }
    return responce ? await loadTeamLocalData(key) : null
  } else {
    return await loadModuleData(key, ModuleInfo.Tables.ModulesTeamMembers, phonegap)
  }
}
export const loadContentPagesData = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let responce = await loadModuleData(key, ModuleInfo.Tables.ModulesContentPages, phonegap)
    if (responce) {
      if (responce.Parent !== null || responce.Persons !== null) {
        addUpdatesyncTime(ModuleInfo.Modules.News.moduleId, key)
      }

      if (responce.Parent !== null) {
        await dbInteractions.mergeModulesContentPages(responce.Parent)
      }

      if (responce.ContentPages !== null) {
        await dbInteractions.mergeModulesContentPagesPosts(responce.ContentPages)
      }
    }
    return responce ? await loadContentPagesLocalData(key) : null
  } else {
    return await loadModuleData(key, ModuleInfo.Tables.ModulesContentPages, phonegap)
  }
}
export const loadContentPagesLocalData = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let contentPageInfo = {
      Parent: null,
      ContentPages: []
    }
    let contentPagesParent = await dbInteractions.selectModulesContentPages(key)
    if (contentPagesParent.length > 0) {
      contentPageInfo.Parent = contentPagesParent[0]

      let contentPagePosts = await dbInteractions.selectModulesContentPagesPosts(contentPageInfo.Parent.Id, contentPageInfo.Parent.PostCategories)

      if (contentPagePosts.length > 0) {
        contentPageInfo.ContentPages = contentPagePosts
      }
    }
    return contentPageInfo
  }
}
export const loadRadioStreamData = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let responce = await loadModuleData(key, ModuleInfo.Tables.ModulesRadioStream, phonegap)
    if (responce) {
      if (Helper.IsValid(responce, true)) {
        addUpdatesyncTime(responce.Module_Id, key)
      }

      if (Helper.IsValid(responce, true)) {
        await dbInteractions.mergeModulesRadioStream(responce)
      }
    }
    return responce ? await loadRadioStreamLocalData(key) : null
  } else {
    return await loadModuleData(key, ModuleInfo.Tables.ModulesRadioStream, phonegap)
  }
}
export const loadRadioStreamLocalData = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let result
    let stream = await dbInteractions.selectModulesRadioStream(key)
    if (stream.length > 0) {
      result = stream[0]
    }
    return result
  }
}
export const loadModulesImageGalleriesLocalData = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let modeuleImageGalleriesInfo = {
      Parent: null,
      Galleries: []
    }
    let modeuleImageGalleriesParent = await dbInteractions.selectModulesImageGalleries(key)

    if (Helper.IsValid(modeuleImageGalleriesParent, true)) {
      modeuleImageGalleriesInfo.Parent = modeuleImageGalleriesParent[0]
      let modeuleImageGalleriesAlbums = await dbInteractions.selectModulesImageGalleriesAlbums(modeuleImageGalleriesParent[0].Id, modeuleImageGalleriesParent[0].PostCategories)
      if (Helper.IsValid(modeuleImageGalleriesAlbums, true)) {
        modeuleImageGalleriesInfo.Galleries = modeuleImageGalleriesAlbums
      }
    }
    return modeuleImageGalleriesInfo
  }
}
export const loadImageGalleriesData = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let responce = await loadModuleData(key, ModuleInfo.Tables.ModulesImageGalleries, phonegap)
    if (responce) {
      if (Helper.IsValid(responce.Parent, true) || Helper.IsValid(responce.Persons, true)) {
        addUpdatesyncTime(ModuleInfo.Modules.ImageGallery.moduleId, key)
      }

      if (Helper.IsValid(responce.Parent, true)) {
        await dbInteractions.mergeModulesImageGalleries(responce.Parent)
      }

      if (Helper.IsValid(responce.Galleries, true)) {
        await dbInteractions.mergeModulesImageGalleriesAlbums(responce.Galleries)
      }
    }
    return responce ? await loadModulesImageGalleriesLocalData(key) : null
  } else {
    return await loadModuleData(key, ModuleInfo.Tables.ModulesImageGalleries, phonegap)
  }
}
export const loadFormLocalData = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let result
    let forms = await dbInteractions.selectModulesForms(key)
    if (forms.length > 0) {
      result = forms[0]
    }
    return result
  }
}
export const loadFormData = async(key) => {
  let phonegap = isPhoneGap()
  if (phonegap) {
    let responce = await loadModuleData(key, ModuleInfo.Tables.ModulesForms, phonegap)
    if (responce) {
      if (Helper.IsValid(responce, true)) {
        addUpdatesyncTime(responce.Module_Id, key)
      }

      if (Helper.IsValid(responce, true)) {
        await dbInteractions.mergeModulesForms(responce)
      }
    }
    return responce ? await loadFormLocalData(key) : null
  } else {
    return await loadModuleData(key, ModuleInfo.Tables.ModulesForms, phonegap)
  }
}
export const loadModuleData = async(key, tablename, IsPhonegap) => {
  let synctime = null
  let appGuid = Helper.GetAppGUID()
  if (IsPhonegap) {
    let syncData = await dbInteractions.selectBootUpSync(key)
    if (syncData.length !== 0) {
      synctime = syncData[0].LastSync
    }
    let response = await Get(`${tablename}/${key}/${appGuid}/${synctime}`)
    return response
  } else {
    let response = await Get(`${tablename}/${key}/${appGuid}/${synctime}`)
    return response
  }
}

export const BootUpSync = async(key) => {
  if (isPhoneGap()) {
    await SyncLocalDb(key)
  } else {
    SyncLocalDb(key)
  }
}

export const addUpdatesyncTime = (syncFor, moduleActivationId) => {
  let syncInfo = {
    LastSync: moment().tz('Europe/Amsterdam').unix(), // moment().unix(),
    SyncFor: syncFor,
    ModuleActivationId: moduleActivationId
  }
  return dbInteractions.mergeBootUpSync(syncInfo)
}

export const SyncData = async(key, syncTime) => {
  let appGuid = Helper.GetAppGUID(key)
  let data = await Get(`BootUpSync/${key}/${appGuid}/${syncTime}`)
  // console.log('BootUpSync data Get', data)
  if (data) {
    addUpdatesyncTime(ModuleInfo.Modules.BootySync.moduleId, ModuleInfo.Modules.BootySync.moduleId)
    // if (data.AppImages !== null) {
    //   addUpdatesyncTime(ModuleInfo.Modules.AppImages.moduleId, ModuleInfo.Modules.AppImages.moduleId)
    //   dbInteractions.mergeSubscriptionsAppImages(data.AppImages)
    // }
    if (data.AppConfig.DesignSettings || data.AppConfig.MainMenu || (data.AppConfig.Modules && data.AppConfig.Modules.Items)) {
      addUpdatesyncTime(ModuleInfo.Modules.AppConfig.moduleId, ModuleInfo.Modules.AppConfig.moduleId)
    }
    if (data.AppConfig.DesignSettings) {
      dbInteractions.mergeSubscriptionsDesignSettings(data.AppConfig.DesignSettings)
    }
    if (data.AppConfig.MainMenu) {
      dbInteractions.mergeSubscriptionsStartPages(data.AppConfig.MainMenu)
    }
    if (data.AppConfig.Modules) {
      // console.log('data.AppConfig.Modules', data.AppConfig.Modules)
      dbInteractions.mergeSubscriptionsModules(data.AppConfig.Modules.Items)
    }
    // console.log('design data save')
    if (data.Modules.TeamMembers) {
      data.Modules.TeamMembers.forEach(team => {
        if (team.Parent !== null) {
          addUpdatesyncTime(team.Parent.Module_Id,
            team.Parent.SubscriptionModule_Id)
        }
        if (team.Parent !== null) {
          dbInteractions.mergeModulesTeamMembers(team.Parent)
        }
        if (team.Persons !== null) {
          dbInteractions.mergeModulesTeamMembersPersons(team.Persons)
        }
      })
    }
    // console.log('team member data save')
    if (data.Modules.ContentPages) {
      data.Modules.ContentPages.forEach(page => {
        if (page.Parent !== null) {
          addUpdatesyncTime(page.Parent.Module_Id,
            page.Parent.SubscriptionModule_Id)
        }
        if (page.Parent !== null) {
          dbInteractions.mergeModulesContentPages(page.Parent)
        }
        if (page.ContentPages !== null) {
          dbInteractions.mergeModulesContentPagesPosts(page.ContentPages)
        }
      })
    }
    // console.log('ContentPage data save')
    if (data.Modules.ImageGalleries) {
      data.Modules.ImageGalleries.forEach(gallery => {
        if (gallery.Parent !== null) {
          addUpdatesyncTime(gallery.Parent.Module_Id,
            gallery.Parent.SubscriptionModule_Id)
        }
        if (gallery.Parent !== null) {
          dbInteractions.mergeModulesImageGalleries(gallery.Parent)
        }
        if (gallery.Galleries !== null) {
          dbInteractions.mergeModulesImageGalleriesAlbums(gallery.Galleries)
        }
      })
    }
    // console.log('Image gallery data save')
    if (data.Modules.RadioStream) {
      data.Modules.RadioStream.forEach(stream => {
        if (Helper.IsValid(stream, true)) {
          addUpdatesyncTime(stream.Module_Id,
            stream.SubscriptionModule_Id)
          dbInteractions.mergeModulesRadioStream(stream)
        }
      })
    }
    // console.log('RadioStream data save')
    if (data.Modules.ModuleForms) {
      data.Modules.ModuleForms.forEach(form => {
        if (Helper.IsValid(form, true)) {
          addUpdatesyncTime(form.Module_Id,
            form.SubscriptionModule_Id)
          dbInteractions.mergeModulesForms(form)
        }
      })
    }
    // console.log('ModuleForms data save')
    if (data.Modules.ModuleRSSFeed) {
      data.Modules.ModuleRSSFeed.forEach(rssfeed => {
        if (Helper.IsValid(rssfeed, true)) {
          addUpdatesyncTime(rssfeed.Module_Id,
            rssfeed.SubscriptionModule_Id)
          dbInteractions.mergeModulesRssFeed(rssfeed)
        }
      })
    }
    // console.log('RssFeed data save')
    if (data.Modules.ModuleYoutube) {
      data.Modules.ModuleYoutube.forEach(youtube => {
        if (Helper.IsValid(youtube, true)) {
          addUpdatesyncTime(youtube.Module_Id,
            youtube.SubscriptionModule_Id)
          dbInteractions.mergeModulesYoutube(youtube)
        }
      })
    }
    // console.log('ModuleYoutube data save')
    if (data.Modules.ModuleFacebook) {
      data.Modules.ModuleFacebook.forEach(facebook => {
        if (Helper.IsValid(facebook, true)) {
          addUpdatesyncTime(facebook.Module_Id,
            facebook.SubscriptionModule_Id)
          dbInteractions.mergeModulesFacebook(facebook)
        }
      })
    }
    // console.log('ModuleFacebook data save')
    if (data.Modules.ModuleTwitter) {
      data.Modules.ModuleTwitter.forEach(twitter => {
        if (Helper.IsValid(twitter, true)) {
          addUpdatesyncTime(twitter.Module_Id,
            twitter.SubscriptionModule_Id)
          dbInteractions.mergeModulesTwitter(twitter)
        }
      })
    }
    // console.log('ModuleTwitter data save')
    if (data.Modules.ModuleInstagram) {
      data.Modules.ModuleInstagram.forEach(instagram => {
        if (Helper.IsValid(instagram, true)) {
          addUpdatesyncTime(instagram.Module_Id,
            instagram.SubscriptionModule_Id)
          dbInteractions.mergeModulesInstagram(instagram)
        }
      })
    }
    // console.log('ModuleInstagram data save')
    if (data.Modules.ModuleChat) {
      data.Modules.ModuleChat.forEach(chat => {
        if (Helper.IsValid(chat, true)) {
          addUpdatesyncTime(chat.Module_Id,
            chat.SubscriptionModule_Id)
          dbInteractions.mergeModulesChat(chat)
        }
      })
    }
    // console.log('ModuleChat data save')
    if (data.Modules.ModuleWebsite) {
      data.Modules.ModuleWebsite.forEach(website => {
        if (Helper.IsValid(website, true)) {
          addUpdatesyncTime(website.Module_Id,
            website.SubscriptionModule_Id)
          dbInteractions.mergeModulesWebsite(website)
        }
      })
    }
    // console.log('ModuleWebsite data save')
  }
}

export const SyncLocalDb = async(key) => {
  let syncData = await dbInteractions.selectBootUpSync(ModuleInfo.Modules.BootySync.moduleId)
  // console.log('syncData', syncData)
  if (syncData.length !== 0) {
    await SyncData(key, syncData[0].LastSync)
  } else {
    await SyncData(key, null)
  }
}



// WEBPACK FOOTER //
// ./src/modules/wrapper/dataProviderWrapper.js